export const SET_JOB_TAGS = 'SET_JOB_TAGS';

export function setJobTags(payload) {
  return {
    type: SET_JOB_TAGS,
    payload
  };
}
